export const sectionKeys = {
  all: ['sections'] as const,
  lists: () => [...sectionKeys.all, 'list'] as const,
  list: () => [...sectionKeys.lists()] as const,
  details: () => [...sectionKeys.all, 'detail'] as const,
  detail: (sectionId: string) => [...sectionKeys.details(), sectionId] as const,
  categories: (sectionId: string) => [...sectionKeys.detail(sectionId), 'categories'] as const,
};
